import { render, staticRenderFns } from "./SetupDevice.vue?vue&type=template&id=0788f584&scoped=true"
import script from "./SetupDevice.vue?vue&type=script&lang=js"
export * from "./SetupDevice.vue?vue&type=script&lang=js"
import style0 from "./SetupDevice.vue?vue&type=style&index=0&id=0788f584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0788f584",
  null
  
)

/* custom blocks */
import block0 from "./SetupDevice.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports